import { InfoIcon } from 'lucide-react';
import React from 'react';

const TabHeader = ({ title = '', icon = '', subTitle = '' }) => {
  return (
    <div className='tw-flex-col tw-gap-1'>
      <div className='tw-text-700 tw-font-medium tw-text-grey-900 tw-py-5 tw-flex tw-items-center tw-leading-none tw-gap-2'>
        {title} {icon}
      </div>
      {subTitle && (
        <div className='tw-text-[1.4rem] tw-font-medium tw-flex tw-items-center tw-gap-2 tw-leading tw-text-zinc-700 tw-px-4 tw-p-3 tw-bg-yellow-200/80 tw-rounded-lg tw-w-fit'>
          <InfoIcon size={16} />
          {subTitle}
        </div>
      )}
    </div>
  );
};

export default TabHeader;
